import React from 'react';
import { useHistory } from 'react-router-dom';

import ConlicitasegSignupMessage from 'components/molecules/conlicitaseg_signup_message';
import ConlicitasegSignupLayout from 'components/organisms/conlicitaseg_signup_layout';

const ConlicitasegEmailValidation: React.FC = () => {
  const history = useHistory();

  const handleAccess = () => {
    localStorage.setItem('redirectAfterLogin', '/conlicitaseg/only-onboarding');
    history.push('/');
  };

  return (
    <ConlicitasegSignupLayout>
      <ConlicitasegSignupMessage icon="check_circle" title="E-mail validado!">
        <p className="mb-4">
          Seu acesso ao ConlicitaSeg está liberado. Entre com seu e-mail e senha para fazer suas
          cotações de Seguro Garantia.
        </p>
        <button type="button" className="btn btn-primary btn-block" onClick={handleAccess}>
          Acessar o ConlicitaSeg
        </button>
      </ConlicitasegSignupMessage>
    </ConlicitasegSignupLayout>
  );
};

export default ConlicitasegEmailValidation;
